module.exports = __webpack_public_path__ + "35c650559af8429558c4ee29ae93bb0f.png";